module.exports = __webpack_public_path__ + "img/footer.e2ab71b7.png";